var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"id":"Preamble"}},[_c('header',[_c('h1',{class:_vm.isTitleCenter ? 'center-title' : ''},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"signature"},[_vm._v(_vm._s(_vm.signature))])]),_c('p',{staticClass:"letter-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }